export default __webpack_public_path__ + "static/media/Play-Clips.d501c594.svg";